// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Próbálkozzon újra egy teljes dátummal, például: ' + p['dateExample'] + '.',
  chart_labelGroup: () => 'Csoport',
  chart_labelSeries: () => 'Sorozat',
  chart_labelValue: () => 'Érték',
  checkboxSet_requiredMessageDetail: () => 'Kötelező',
  checkbox_requiredMessageDetail: () => 'Kötelező',
  close: () => 'Bezárás',
  collection_noData: () => 'Nincs megjeleníthető adat.',
  collection_selectAllRows: () => 'Minden sor kijelölése',
  collection_selectRow: (p: { ROW_NAME: string }) => p['ROW_NAME'] + '. sor kijelölése',
  collection_sortDisabled: () => 'Nem rendezhető',
  collection_sortEnabled: () => 'Rendezhető',
  confirmation: () => 'Megerősítés',
  dataVisualization_labelAndValue: (p: { LABEL: string; VALUE: string }) =>
    p['LABEL'] + ': ' + p['VALUE'],
  dataVisualization_labelCountWithTotal: (p: { totalCount: string; itemCount: string }) =>
    p['totalCount'] + '/' + p['itemCount'],
  dataVisualization_noData: () => 'Nincs megjeleníthető adat',
  dataVisualization_stateSelected: () => 'Kijelölt',
  dataVisualization_stateUnselected: () => 'Nem kijelölt',
  error: () => 'Hiba',
  expandableList_expandCollapseInstructionText: () =>
    'A kibontáshoz és összecsukáshoz használja a nyílbillentyűket',
  expandableList_groupCollapse: () => 'Összecsukott',
  expandableList_groupExpand: () => 'Kibontott',
  filePicker_addFiles: () => 'Fájlok hozzáadása',
  filePicker_dropzonePrimaryText: () => 'Áthelyezés húzással',
  filePicker_dropzoneSecondaryText: () => 'Válassza ki a fájlt, vagy húzza át ide',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Válassza ki a fájlokat, vagy húzza át ide',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Nem tölthet fel ' + p['fileTypes'] + ' típusú fájlt',
  filePicker_singleFileUploadError: () => 'Egyszerre csak egy fájlt töltsön fel',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Nem tölthet fel ' + p['fileType'] + ' típusú fájlt',
  filePicker_unknownFileTypeUploadError: () => 'ismeretlen',
  formControl_clear: () => 'Törlés',
  formControl_day: () => 'Nap',
  formControl_helpAvailable: () => 'Elérhető súgó',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Elérte a(z) ' +
    ((
      { one: new Intl.NumberFormat('hu').format(p['CHARACTER_LIMIT']) + ' karakteres' } as Partial<
        Record<Intl.LDMLPluralRule, string>
      >
    )[new Intl.PluralRules('hu').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('hu').format(p['CHARACTER_LIMIT']) + ' karakteres') +
    ' korlátot.',
  formControl_loading: () => 'Betöltés',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Túllépte a maximális hosszt: ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' karakter maradt.',
  formControl_month: () => 'Hónap',
  formControl_readOnly: () => 'Írásvédett',
  formControl_requiredMessageDetail: () => 'Adjon meg egy értéket.',
  formControl_year: () => 'Év',
  gantt_labelDate: () => 'Dátum',
  gantt_labelEnd: () => 'Befejezés',
  gantt_labelLabel: () => 'Címke',
  gantt_labelRow: () => 'Sor',
  gantt_labelStart: () => 'Kezdés',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nem található egyező szakasz.',
  indexer_keyboardInstructionText: () => 'Az érték kiválasztásához nyomja meg az Enter billentyűt.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    p['FROM_SECTION'] + ' és ' + p['TO_SECTION'] + ' között.',
  indexer_touchInstructionText: () =>
    'A gesztus módba belépéshez dupla koppintás és megtartás, majd lefelé vagy felfelé húzás az érték beállításához.',
  info: () => 'Információ',
  inputDateMask_date_cleared: () => 'Törlés dátuma',
  inputDateMask_dayPlaceholder: () => 'nn',
  inputDateMask_empty_segment: () => 'Kiürítés',
  inputDateMask_monthPlaceholder: () => 'hh',
  inputDateMask_yearPlaceholder: () => 'éééé',
  inputNumber_converterParseError: () => 'Adjon meg egy számot.',
  inputNumber_decrease: () => 'Csökkentés',
  inputNumber_increase: () => 'Növelés',
  inputPassword_hidden: () => 'Jelszó elrejtve',
  inputPassword_hide: () => 'Jelszó elrejtése',
  inputPassword_show: () => 'Jelszó megjelenítése',
  list_suggestion: () => 'Javaslat',
  messageToast_allMessagesClosed: () => 'Az összes információs üzenet bezárva.',
  message_close: () => 'Bezárás',
  message_confirmation: () => 'Siker',
  message_error: () => 'Hiba',
  message_info: () => 'Információ',
  message_navigationFromMessagesRegion: () =>
    'Belépés az üzenetek régióba. Az F6 billentyűvel léphet a korábban kijelölt elemhez.',
  message_navigationToMessagesRegion: () =>
    'Az üzenetek régióban új üzenetek találhatók. Az F6 billentyűvel léphet a legutóbbi üzenetrégióhoz.',
  message_warning: () => 'Figyelmeztetés',
  noData_message: () => 'Nincs megjeleníthető elem',
  overflowItemLabel: () => 'További lapok',
  plural_separator: () => ', ',
  progressIndeterminate: () => 'Folyamatban',
  radio_helpForRadio: () => 'Súgó választógombhoz',
  radio_requiredMessageDetail: () => 'Jelöljön ki egy értéket.',
  selectMultiple_apply: () => 'Alkalmaz',
  selectMultiple_back: () => 'Vissza',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'A kijelölt érték eltávolításához nyomja meg a Backspace vagy a Delete billentyűt.',
  selectMultiple_selectedValues: () => 'Kiválasztott értékek',
  selectMultiple_showSelectedValues: () => 'Csak a kijelölt értékek megjelenítése.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' kiválasztott érték.',
  select_addToList: () => 'Hozzáadás listához',
  select_addToListAvailable: () => 'Hozzáadás listához elérhető',
  select_moreSearchOptions: () => 'További keresési beállítások',
  select_moreSearchOptionsAvailable: () => 'További keresési beállítások elérhetők',
  select_noMatchesFound: () => 'Nincs találat.',
  select_oneMatchFound: () => 'Egy egyezés található',
  select_requiredMessageDetail: () => 'Jelöljön ki egy értéket.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => p['TOTAL_SIZE'] + ' egyezés található',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' vagy több egyezés található',
  selector_selected: () => 'Jelölőnégyzet bejelölve',
  selector_unselected: () => 'Jelölőnégyzet nincs bejelölve',
  tabBarNavigationList_removeCueText: () => 'Eltávolítható',
  timeComponent_tooltipZoomIn: () => 'Nagyítás',
  timeComponent_tooltipZoomOut: () => 'Kicsinyítés',
  train_current: () => 'Aktuális',
  train_message_type: () => 'Üzenet típusa',
  train_not_visited: () => 'Nem látogatott',
  train_status: (p: { numberOfSteps: string; currentStep: string }) =>
    p['numberOfSteps'] + '/' + p['currentStep'] + '. lépés',
  train_visited: () => 'Látogatott',
  userAssistance_learnMore: () => 'További tudnivalók',
  userAssistance_required: () => 'Kötelező',
  viz_drillable: () => 'Részletezhető',
  warn: () => 'Figyelmeztetés'
};
export default bundle;
